import { disablePageScroll, enableScroll } from '../utils/scroll';

export default function header($) {
  const btn = document.querySelector('.menu-btn');
  let menuOpened = false;
  let disableScrollTimeout;

  function openMenu() {
    if (menuOpened) return;
    clearTimeout(disableScrollTimeout);
    menuOpened = true;
    disableScrollTimeout = setTimeout(() => {
      disablePageScroll(true);
    }, 300);
    document.body.classList.add('menu-opened');
    document.body.dispatchEvent(new CustomEvent('menu-opened'));
  }

  function closeMenu() {
    if (!menuOpened) return;
    clearTimeout(disableScrollTimeout);
    menuOpened = false;
    document.body.classList.remove('menu-opened');
    document.body.dispatchEvent(new CustomEvent('menu-closed'));
    enableScroll();
  }

  if (btn) {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      menuOpened ? closeMenu() : openMenu();
    });
  }

  const $window = $(window);
  const $headerInner = $('.header__inner');
  let headerFixed = false;
  let headerVisible = false;
  let currentScrollTop = $window.scrollTop();

  $window.on('scroll', () => {
    const newScrollTop = $window.scrollTop();
    if (Math.abs(currentScrollTop - newScrollTop) < 50 && newScrollTop >= 5) return;

    if (!headerFixed && newScrollTop > 120) {
      $headerInner.addClass('header__inner--fixed');
      headerFixed = true;
    } else if (headerFixed && newScrollTop < 5) {
      $headerInner.removeClass('header__inner--fixed').removeClass('header__inner--visible');
      headerFixed = false;
      headerVisible = false;
    }

    if (headerFixed) {
      if (newScrollTop > currentScrollTop && headerVisible) {
        $headerInner.removeClass('header__inner--visible');
        headerVisible = false;
      } else if (newScrollTop < currentScrollTop && !headerVisible) {
        $headerInner.addClass('header__inner--visible');
        headerVisible = true;
      }
    }

    currentScrollTop = newScrollTop;
  });
}
